import { render, staticRenderFns } from "./PayPalCasesCreationSection.vue?vue&type=template&id=39c30d89"
import script from "./PayPalCasesCreationSection.vue?vue&type=script&lang=js"
export * from "./PayPalCasesCreationSection.vue?vue&type=script&lang=js"
import style0 from "./PayPalCasesCreationSection.vue?vue&type=style&index=0&id=39c30d89&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports